import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationDialogComponent } from './organization-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    OrganizationDialogComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    MessageModule,
    TranslateModule,
  ],
  exports: [
    OrganizationDialogComponent
  ]
})
export class OrganizationDialogModule { }
